import { useEffect, useState } from "react";
import { api, euro } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const REASONS = { belegt: "belegt", gesperrt: "gesperrt", mindestaufenthalt: "Mindestaufenthalt nicht erreicht", zu_viele_gaeste: "zu viele Gäste" };

export const QuoteSimulator = ({ slug, maxGuests }) => {
  const [ci, setCi] = useState("");
  const [co, setCo] = useState("");
  const [adults, setAdults] = useState(2);
  const [kids, setKids] = useState("");
  const [code, setCode] = useState("");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { setAdults(Math.min(2, maxGuests || 2)); setRes(null); }, [slug, maxGuests]);

  const run = async () => {
    setErr(""); setRes(null);
    try {
      const ages = kids.split(/[,; ]+/).filter(Boolean).map(Number);
      const { data } = await api.post("/rates/quote", { room: slug, check_in: ci, check_out: co, adults: Number(adults), children_ages: ages, discount_code: code || null });
      setRes(data);
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(Array.isArray(d) ? d.map((x) => x.msg).join(", ") : d || "Berechnung fehlgeschlagen");
    }
  };

  return (
    <div className="rounded-xl border border-border bg-card p-5 space-y-3" data-testid="quote-simulator">
      <h3 className="font-semibold">Preis-Rechner (wie auf der Homepage)</h3>
      <div className="grid grid-cols-2 gap-2">
        <label className="text-xs">Anreise<Input type="date" value={ci} onChange={(e) => setCi(e.target.value)} data-testid="quote-ci"/></label>
        <label className="text-xs">Abreise<Input type="date" value={co} onChange={(e) => setCo(e.target.value)} data-testid="quote-co"/></label>
        <label className="text-xs">Erwachsene<Input type="number" min="1" value={adults} onChange={(e) => setAdults(e.target.value)} data-testid="quote-adults"/></label>
        <label className="text-xs">Kinder-Alter<Input value={kids} onChange={(e) => setKids(e.target.value)} placeholder="z. B. 8, 15" data-testid="quote-kids"/></label>
        <label className="text-xs col-span-2">Rabattcode (optional)<Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} data-testid="quote-code"/></label>
      </div>
      <Button variant="outline" onClick={run} className="w-full rounded-xl" data-testid="quote-run">Berechnen</Button>
      {err && <p className="text-sm text-red-600" data-testid="quote-error">{err}</p>}
      {res && (
        <div className="text-sm space-y-1" data-testid="quote-result">
          <div className={`font-semibold ${res.bookable ? "text-emerald-700" : "text-red-600"}`}>
            {res.bookable ? "Buchbar" : `Nicht buchbar: ${REASONS[res.reason] || res.reason}`} · {res.nights} {res.nights === 1 ? "Nacht" : "Nächte"} (mind. {res.min_stay})
          </div>
          <div className="max-h-40 overflow-y-auto text-xs text-muted-foreground">
            {res.per_night.map((n) => <div key={n.date} className="flex justify-between"><span>{n.date.split("-").reverse().join(".")} · {n.rule}</span><span>{euro(n.price)}</span></div>)}
            {res.surcharges.map((s) => <div key={s.label} className="flex justify-between"><span>{s.label}</span><span>+ {euro(s.amount)}</span></div>)}
            {(res.discounts || []).map((s) => <div key={s.label} className="flex justify-between text-emerald-700 font-medium" data-testid="quote-discount"><span>{s.label}</span><span>− {euro(-s.amount)}</span></div>)}
          </div>
          <div className="flex justify-between font-bold border-t border-border pt-1"><span>Gesamt</span><span data-testid="quote-total">{euro(res.total)}</span></div>
          {res.code_status && res.code_status !== "ok" && (
            <p className="text-xs text-amber-700" data-testid="quote-code-status">Rabattcode nicht angewendet: {{ ungueltig: "unbekannt", pausiert: "auf Halt", nicht_im_zeitraum: "gilt nicht für diesen Zeitraum" }[res.code_status] || res.code_status}</p>
          )}
        </div>
      )}
    </div>
  );
};
